import { Api } from "@core/api/api";

const CHAT_URL = "/chats";

export class MessagingApi {
	constructor(private readonly api: Api) {}

	async createToken(): Promise<string> {
		const result = await this.api.get<string>(`${CHAT_URL}/createToken`);
		return result.data;
	}
}
